module.exports = __webpack_public_path__ + "static/media/1013462.0f3f34f6.png";